import { Component, Inject, OnInit } from '@angular/core';
import {FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EvidenceAbntType } from 'app/shared/objects/certification';
import { FileUploader } from 'ng2-file-upload';

@Component({
  selector: 'app-dialog-attach-evidence',
  templateUrl: './dialog-attach-evidence.component.html',
  styleUrls: ['./dialog-attach-evidence.component.scss']
})
export class DialogAttachEvidenceComponent implements OnInit {

  public isReview: boolean = false;

	public uploader: FileUploader;
	public hasFile = false;

  public evidenceType: EvidenceAbntType;

  public form: UntypedFormGroup;
  protected linkCtrl: UntypedFormControl
  protected descriptionCtrl: UntypedFormControl

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly dialogRef: MatDialogRef<DialogAttachEvidenceComponent>,
    private readonly fb: UntypedFormBuilder,
    private readonly snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {

    this.form = this.fb.group({
      file: [null],
      fileUrl: [null],
      description: [null],
      link: [null]
    });

    this.linkCtrl = this.form.get('link') as FormControl<any>
    this.descriptionCtrl = this.form.get('description') as FormControl<any>

    this.evidenceType = this.data.evidenceType;
    this.setValidators(this.evidenceType);

    this.isReview = !!this.data?.preview;
    if (this.data?.preview) {
      this.form.patchValue({
        fileUrl: this.data.preview?.fileUrl,
        description: this.data.preview?.description,
        link: this.data.preview?.link,
      });

      this.form.get('fileUrl').disable();
      this.form.get('description').disable();
      this.form.get('link').disable();
    }
  }

  get file(): File {
    return this.form.get('file').value;
  }

  get fileUrl(): string {
    return this.form.get('fileUrl').value;
  }

  get link(): string {
    return this.form.get('link').value;
  }

  public setValidators(evidenceType: EvidenceAbntType): void {
    if (evidenceType === EvidenceAbntType.DOCUMENT) {
      this.form.get('file').setValidators(Validators.required);
      this.form.updateValueAndValidity()
    }

    if (evidenceType === EvidenceAbntType.LINK) {
      this.form.get('link').setValidators(Validators.required);
      this.form.updateValueAndValidity()
    }
  }

  public fileOver(e) {
    
    const file = e.addedFiles[0];
    
    if (file.type !== 'application/pdf') {
      this.snackBar.open('Somente PDF é permitido', null, { duration: 3000 });
      return;
    }

    if (file.size > 10485760) { // 10MB
      this.snackBar.open('Tamanho máximo 10MB', null, { duration: 3000 });
      return;
    }

    this.hasFile = e;
    this._onChangeFileInput(file);
	}

  private async _onChangeFileInput(file) {
    this.form.patchValue({ file: file });
  }

  public onCancel(): void {
    this.dialogRef.close();
  }

  public onSubmit(form: UntypedFormGroup): void {
    if (form.valid) {
      this.dialogRef.close(form.getRawValue());
    }
  }

  public clearFile(): void {
    this.form.patchValue({ file: null })
  }

}
